import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import { IBudget } from '../../../../models/budgetV2';

import { BudgetCurrencyInput } from '../../components/budgetInputs/BudgetCurrencyInput';

interface IBudgetCounterProposalProps {
  budget?: IBudget | null;
  readOnly?: boolean;

  onValueChange?: (value: number) => void;
  onObservationChange?: (value: string) => void;
}

export const CounterProposal = (props: IBudgetCounterProposalProps) => {
  const intl = useIntl();

  const  {budget, readOnly, onValueChange, onObservationChange} = props;

  if (!budget) return null;

  const [observation, setObservation] = useState<string>(budget.versionData?.counterProposalObservation || '');
  const [value, setValue] = useState<number>(budget.versionData?.counterProposalValue || 0);

  const handleObservationChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = e.target.value;
      setObservation(newValue);
      onObservationChange?.(newValue);
    },
    [props],
  );

  const handleValueChange = useCallback(
    (newValue: number) => {
      setValue(newValue);
      onValueChange?.(newValue);
    },
    [props],
  );

  const formatCurrency = (val: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(val);
  };

  return (
    <div className="m-6 px-4 border-2  border-gray-100 rounded-md p-4">
      <div className="flex flex-row items-center mb-4">
        <div className="font-bold text-size-14 text-gray-700">{intl.formatMessage({ id: 'intl-msg:budgets.counterProposal' })}</div>
      </div>

      <div className="flex flex-row gap-4">
        <div className="flex-1">
          <div className="font-bold mb-2 text-size-12 text-gray-500">{intl.formatMessage({ id: 'intl-msg:budgets.counterProposalObservation' })}</div>
          {readOnly ? (
            <div className="p-2 bg-white rounded border border-gray-200 min-h-[40px] text-size-14">
              {observation || '-'}
            </div>
          ) : (
            <textarea
              className="form-control w-full"
              rows={1}
              placeholder={intl.formatMessage({ id: 'intl-msg:budgets.counterProposalObservationPlaceholder' })}
              value={observation}
              onChange={handleObservationChange}
            />
          )}
        </div>

        <div className="w-45 ml-2">
          <div className="font-bold mb-2 text-size-12 text-gray-500">{intl.formatMessage({ id: 'intl-msg:budgets.counterProposalValue' })}</div>
          {readOnly ? (
            <div className="p-2 bg-white rounded border border-gray-200 min-h-[40px] text-size-14 flex items-center">
              {value > 0 ? formatCurrency(value) : '-'}
            </div>
          ) : (
            <BudgetCurrencyInput value={value} onChange={handleValueChange} placeholder="R$ 0,00" />
          )}
        </div>
      </div>
    </div>
  );
};
